import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import TableActionsWrapper from 'components/TableActionsWrapper';
import TableButton from 'components/TableButton';

import hashIds from 'services/hashIds';

interface CustomizedServiceActionsProps {
  selectedCount: number;
  loading: boolean;
  selectedRows: {
    idServico: number;
  }[];
  deleteCustomizedService: () => void;
}

const CustomizedServiceActions: React.FC<CustomizedServiceActionsProps> = ({
  loading,
  selectedCount,
  selectedRows,
  deleteCustomizedService,
}) => {
  const { t } = useTranslation();

  const serviceHashId = hashIds.encode(selectedRows[0].idServico);

  return (
    <TableActionsWrapper loading={loading}>
      {selectedCount === 1 && (
        <>
          <TableButton
            forwardedAs={Link}
            to={`/servicos/customizados/editar/${serviceHashId}`}
            size="sm"
            className="mx-1"
            disabled={loading}
          >
            {t('common:edit')}
          </TableButton>
          <TableButton
            className="mx-1"
            variant="danger"
            size="sm"
            disabled={loading}
            onClick={() => deleteCustomizedService()}
          >
            {t('common:delete')}
          </TableButton>
        </>
      )}
    </TableActionsWrapper>
  );
};

export default CustomizedServiceActions;
